import { render, staticRenderFns } from "./ParcelDeliveryTermsSection.vue?vue&type=template&id=0e799c14&scoped=true&"
import script from "./ParcelDeliveryTermsSection.vue?vue&type=script&lang=js&"
export * from "./ParcelDeliveryTermsSection.vue?vue&type=script&lang=js&"
import style0 from "./ParcelDeliveryTermsSection.vue?vue&type=style&index=0&id=0e799c14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e799c14",
  null
  
)

export default component.exports